import { cn } from "@/libs/utils";

/**
 * 홈 리뉴얼 섹션 공통 헤딩 — 피그마 "Frame 13"(28983:91472 / 91476 / 91480 / 29032:93778).
 *
 * 제목 36/44 Regular · 부제 16/22 Regular(ls .5) · 둘 다 Cool Gray/90 · 세로 gap 16.
 * 모바일(<1024)은 24/32 · 14/18 · gap 12 (디자이너 공유 HTML `@media (max-width:1023px)`).
 *
 * ⚠️ 임의 px 을 쓰지 않는다 — 이 레포의 타입 스케일이 피그마 램프와 1:1 로 맞는다.
 *   text-6xl 36/44 · text-3xl 24/32 · text-lg 16/22 · text-base 14/18
 * ⚠️ 부제도 제목과 **같은 Cool Gray/90** 이다(피그마에서 헤딩 프레임 전체가 #21272A).
 *   기존 구현은 coolgray-70 이었다 — 되돌리지 말 것.
 */
export default function SectionHeading({
  title,
  description,
  className,
}: {
  title: string;
  description?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center gap-3 text-center text-coolgray-90 laptop:gap-4",
        className,
      )}
    >
      <h2 className="text-3xl font-400 laptop:text-6xl">{title}</h2>
      {description && (
        <p className="text-base font-400 tracking-[0.25px] laptop:text-lg laptop:tracking-[0.5px]">
          {description}
        </p>
      )}
    </div>
  );
}
